<template>
    <div class="wrap">
        <myHead></myHead>
        <div class="wrap_body">
            <div class="center">
                <div class="ucenter_main">
                    <ucMenu num="31"></ucMenu>
                    <div class="right_con">
                        <div class="rc_main">
                            <p class="fb">商品优化</p>
                            <el-tabs v-model="activeTab" @tab-click="handleTabChange">
                                <el-tab-pane label="AI标题" name="aiTitle">
                                    <ai-title-replace-task :groupList="groupList" ref="AiTitleReplaceTask"></ai-title-replace-task>
                                </el-tab-pane>
<!--                                <el-tab-pane label="AI生成白底图" name="aiImgGenerateWhite">
                                    <ai-img-generate-white-task :groupList="groupList" ref="AiImgGenerateWhiteTask"></ai-img-generate-white-task>
                                </el-tab-pane>
                                <el-tab-pane label="批量生成3/4" name="aiImgGenerateThreeToFourTask">
                                    <ai-img-generate-three-to-four-task :groupList="groupList" ref="aiImgGenerateThreeToFourTask"></ai-img-generate-three-to-four-task>
                                </el-tab-pane>-->
                                <el-tab-pane label="AI生成白底图" name="aiImgGenerateWhiteBg">
                                  <ai-img-generate :groupList="groupList" :target-direction="1" ref="AiImgGenerateWhiteBg"></ai-img-generate>
                                </el-tab-pane>
                                <el-tab-pane label="AI生成3/4图" name="aiImgGenerateThreeToFour">
                                    <ai-img-generate :groupList="groupList" :target-direction="2" ref="aiImgGenerateThreeToFour"></ai-img-generate>
                                </el-tab-pane>
                                <el-tab-pane label="AI生视频" name="aiImgGenerateVideo">
                                    <ai-img-generate :groupList="groupList" :target-direction="3" ref="aiImgGenerateVideo"></ai-img-generate>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <myFoot></myFoot>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import AiTitleReplaceTask from "./aiTitleReplace/aiTitleReplaceTask.vue";
import AiImgGenerateWhiteTask from "./aiImg/aiImgGenerateWhiteTask.vue";
import AiImgGenerateThreeToFourTask from "./aiImg/aiImgGenerateThreeToFourTask.vue";
import AiImgGenerate from "./aiImg/aiImgGenerate.vue";

export default {
    name: 'ucenterProduct',
    components: {
        ucMenu,
        myHead,
        myFoot,
        AiTitleReplaceTask,
        AiImgGenerateWhiteTask,
        AiImgGenerateThreeToFourTask,
        AiImgGenerate
    },
    data() {
        return {
            // Tab 控制
            ismanager: true,
            activeTab: 'aiTitle',
            aiTitleStatus: {
                1: { label: '待替换', value: 1, type: 'selected-tag' },
                2: { label: '已替换', value: 2, type: 'replaced-tag' },
                9: { label: '异常', value: 3, type: 'notFond-tag' }
            },
            groupLoading: false,
            groupList: [], // 分组列表
            userinfo:{},

        }
    },
    created() {
        this.getUserInfo()
        this.loadGroupList()
        this.handleTabChange({ name: 'aiTitle' })
    },
    computed: {

    },
    watch: {

    },
    methods: {
        ...mapActions({
            getUserinfoData: "ucenter/getUserinfoData",
            getCloudProductGroups: 'ucenter/getCloudProductGroups',

        }),
        getUserInfo() {
            this.getUserinfoData({
                data: {}, success: (res) => {
                    this.userinfo = res.data
                    // this.power_num = this.userinfo.power_num
                }
            })
        },
        // === Tab 切换 ===
        handleTabChange(tab) {
            if (tab.name === 'aiTitle') {
                this.$nextTick(() => {
                    this.$refs.AiTitleReplaceTask.initData()
                })
            } else if (tab.name === 'aiImgGenerateWhite') {
                this.$nextTick(() => {
                    this.$refs.AiImgGenerateWhiteTask.initData()
                })
            } else if (tab.name === 'aiImgGenerateThreeToFourTask') {
                this.$nextTick(() => {
                    this.$refs.aiImgGenerateThreeToFourTask.initData()
                })
            }else if (tab.name === 'aiImgGenerateWhiteBg') {
                this.$nextTick(() => {
                    this.$refs.AiImgGenerateWhiteBg.initData()
                })
            } else if (tab.name === 'aiImgGenerateThreeToFour') {
                this.$nextTick(() => {
                    this.$refs.aiImgGenerateThreeToFour.initData()
                })
            }else if (tab.name === 'aiImgGenerateVideo') {
                this.$nextTick(() => {
                    this.$refs.aiImgGenerateVideo.initData()
                })
            }
        },
        // 获取分组列表（筛选用，不需要数量）
        loadGroupList() {
            if (this.groupList.length > 0) return
            this.groupLoading = true
            this.getCloudProductGroups({
                data: { with_count: 0 },
                success: (res) => {
                    this.groupLoading = false
                    if (res.code === 200) {
                        this.groupList = res.data || []
                    }
                }
            })
        },


    }
}
</script>


<style scoped>
/*.wrap {
  overflow-x: hidden;
}*/

.center {
    display: flex;
    flex: 1;
}

/*.ucenter_main {
  min-height: 500px;
}*/

.rc_main {
    padding: 36px 40px 46px;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    /* 确保 padding 不会撑大容器宽度，防止溢出 */
}

.table-container {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}

.rc_table {
    width: 100%;
    margin-top: 10px;
    table-layout: fixed;
    min-width: 900px;
}

/* 表格单元格内容过长时，超出部分省略，避免撑破容器 */
.rc_table .cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.op_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

.filter-box {
    margin-top: 10px;
}

.cloud-filter-box .search-row {
    margin-bottom: 10px;
}

.cloud-filter-box .action-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

/* 替换日志链接样式 */
.replace-log-link {
    color: #409EFF;
    text-decoration: none;
    word-break: break-all;
    display: inline-block;
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.replace-log-link:hover {
    color: #66b1ff;
    text-decoration: underline;
}

.replace-log-tip {
    color: #909399;
    font-size: 12px;
    margin-bottom: 10px;
}

.mini-btn {
    padding: 0 5px;
    line-height: 18px;
}
</style>

<style>
/* 图片搜索样式 - 非 scoped 以确保在 dialog 中生效 */


.sku-box {
    height: 80vh;
    display: flex;
    flex-direction: column;
}

/* SKU替换对话框样式重置 - 只影响包含image-search-container-new的对话框 */
.el-dialog__body:has(.image-search-container-new) {
    padding-top: 5px !important;
    /* 减少顶部间距 */
    padding-bottom: 10px !important;
    /* 减少底部间距 */
}

.image-search-container {
    display: flex;
    height: 600px;
    min-height: 0;
    border: 1px solid #e4e7ed;
}

/* 新的三区域布局 */
.image-search-container-new {
    display: flex;
    /*height: 800px; */
    /* 增加高度以提供更多空间 */
    /*max-height: calc(80vh - 280px);*/
    min-height: 0;
    border: 1px solid #e4e7ed;
    /* margin-top: -10px;*/
    /* 向上移动减少与标题间距 */
}

.search-right-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

.product-detail-panel {
    flex-shrink: 0;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    flex-direction: column;
    background: #fff;
    /*max-height: 150px;*/
    /* 进一步减少高度 */
    overflow: hidden;
}

.sku-info-section {
    padding: 0;
    /* 移除内边距 */
    border: none;
    /* 移除边框 */
}

.sku-list {
    max-height: none;
    /* 让容器自适应，由panel的max-height控制 */
    overflow-y: visible;
}

.sub-header {
    font-weight: normal;
    color: #909399;
    font-size: 12px;
    margin-left: 10px;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: bottom;
}

.search-left-panel {
    width: 400px;
    border-right: 1px solid #e4e7ed;
    display: flex;
    flex-direction: column;
    background: #f5f7fa;
}

.search-right-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

.panel-header {
    padding: 10px 15px;
    font-weight: 500;
    border-bottom: 1px solid #e4e7ed;
    background: #fff;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.product-list {
    flex: 1;
    overflow-y: auto;
}

.product-item {
    display: flex;
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    transition: background 0.2s;
}

.product-item:hover {
    background: #ecf5ff;
}

.product-item.active {
    background: #ecf5ff;
    border-left: 3px solid #409eff;
}

.product-item .thumb {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 10px;
}

.product-item .info {
    flex: 1;
    overflow: hidden;
}

.product-item .title {
    font-size: 12px;
    color: #333;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.product-item .price {
    color: #f56c6c;
    font-size: 12px;
    font-weight: 500;
}

.product-item .update-time {
    color: #909399;
    font-size: 10px;
    margin-top: 2px;
}

.product-item.selected {
    background: #f0f9eb;
    border-left: 3px solid #67c23a;
}

.product-item.replaced {
    background: #f5f5f5;
    opacity: 0.7;
    border-left: 3px solid #67c23a;
}

.notFond-tag {
    color: #999999;
    font-size: 10px;
    margin-top: 2px;
}

.selected-tag {
    color: #E6A23C;
    font-size: 10px;
    margin-top: 2px;
}

.replaced-tag {
    color: #67c23a;
    font-size: 10px;
    margin-top: 2px;
    font-weight: bold;
}

.replaced-count {
    color: #67c23a;
    font-size: 12px;
    font-weight: normal;
}

.result-count {
    color: #909399;
    font-size: 12px;
    margin-left: 8px;
}

.panel-pagination {
    padding: 10px 0px;
}

.panel-pagination .el-pagination__jump {
    margin-left: 12px;
}

.panel-pagination .el-pagination .btn-prev {
    padding-right: 8px;
}

.panel-pagination .el-pagination .btn-next {
    padding-left: 8px;
}

.dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.selected-info {
    color: #909399;
    font-size: 13px;
    margin-right: 20px;
}

.sub-header {
    font-weight: normal;
    color: #909399;
    font-size: 12px;
    margin-left: 10px;
}

.current-title {
    color: #409eff;
    max-width: 200px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}

.search-result-grid {
    /*flex: 1;*/
    min-height: 0;
    overflow-y: auto;
    padding: 10px;
    /* 减少内边距 */
    display: grid;
    /*grid-template-columns: repeat(4, 1fr);*/
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    grid-gap: 10px;
    /* 减少间距以容纳更多内容 */
}

.result-item {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: visible;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    background: #fff;
    cursor: default;
    box-sizing: border-box;
}

.result-item:hover {
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

.result-item.is-selected {
    border: 2px solid #67c23a;
    box-shadow: 0 0 8px rgba(103, 194, 58, 0.3);
}

.result-item.is-selected .action-btn:first-child {
    background: #67c23a;
    color: #fff;
}

.result-item.is-selected .action-btn:first-child:hover {
    background: #85ce61;
}

.result-item.is-replaced {
    border: 2px solid #409eff;
    box-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
}

.replaced-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #409eff;
    color: #fff;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 3px;
    z-index: 1;
}

.action-btn.replace-btn {
    color: #409eff;
    font-weight: 500;
}

.action-btn.replace-btn:hover {
    background: #ecf5ff;
}

.action-btn.is-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
    background: #f5f7fa;
}

.action-btn.is-disabled:hover {
    background: #f5f7fa;
}

.result-item .img-wrapper {
    width: 100%;
    aspect-ratio: 1 / 1;
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid #f5f5f5;
    box-sizing: border-box;
    background-color: #f5f7fa;
    flex-shrink: 0;
}

.result-item .result-img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.result-item .result-info {
    padding: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.result-title {
    font-size: 13px;
    color: #333;
    line-height: 1.4;
    height: 36px;
    /* 2 lines */
    overflow: hidden;
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.result-price-row {
    display: flex;
    align-items: baseline;
    margin-bottom: 6px;
}

.result-price-row .price {
    color: #f56c6c;
    font-weight: bold;
    font-size: 16px;
}

.result-price-row .consign-price {
    color: #909399;
    font-size: 12px;
    margin-left: 6px;
}

.result-tags {
    margin-bottom: 4px;
    display: flex;
    flex-wrap: wrap;
}

.mini-tag {
    background-color: #f4f4f5;
    color: #909399;
    font-size: 10px;
    padding: 0 4px;
    border-radius: 2px;
    margin-right: 4px;
    margin-bottom: 4px;
    line-height: 16px;
    display: inline-block;
}

.result-action {
    border-top: 1px solid #ebeef5;
    background: #fff;
    display: flex;
    flex-shrink: 0;
}

.action-btn {
    flex: 1;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 13px;
    color: #606266;
    transition: all 0.3s;
    cursor: pointer;
}

.action-btn:hover {
    color: #409eff;
    background: #f5f7fa;
}

.action-btn.view-btn {
    border-left: 1px solid #ebeef5;
}

.empty-result {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
    min-height: 300px;
}

.empty-result i {
    font-size: 40px;
    margin-bottom: 10px;
}

/* 商品详情面板样式 */
.product-detail-content {
    flex: 1;
    overflow-y: auto;
    padding: 10px 15px;
}

.search-result-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    background: #fff;
}

.search-left-panel {}


.sku-list {
    max-height: 200px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
}

.sku-item {
    width: calc(50% - 20px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f8f9fa;
}

.sku-item:last-child {
    /*border-bottom: none;*/
}

.sku-item:nth-child(2n+0) {
    margin-left: 40px;
}

.sku-spec {
    flex: 1;
    font-size: 13px;
    color: #333;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sku-details {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.sku-price {
    color: #f56c6c;
    font-weight: 500;
    font-size: 12px;
}

.sku-stock {
    color: #67c23a;
    font-size: 12px;
}

.sku-code {
    color: #909399;
    font-size: 11px;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.no-sku-info {
    color: #909399;
    font-size: 13px;
    text-align: center;
    padding: 20px 0;
}

/* 过滤器样式 */

.header-left {
    display: flex;
    align-items: center;
}

.header-right {
    display: flex;
    align-items: center;
}

.filter-count {
    color: #f56c6c;
    font-weight: 500;
    margin-left: 2px;
}

.filter-panel {
    border: 1px solid #ebeef5;
    /* background: #fafbfc;*/
    padding: 8px;
    /* 减少内边距 */
    margin-bottom: 8px;
    margin-top: -10px;
}

/* 二级选择器 */
.cascade-selects {
    /* display: flex;*/
    gap: 8px;
    /*margin-bottom: 8px;*/
    /* 减少下边距 */
    align-items: center;
    flex-wrap: wrap;
}

.category-select,
.option-select {
    min-width: 140px;
}

.category-select .el-input__inner,
.option-select .el-input__inner {
    font-size: 12px;
}

/* 待确认过滤条件 */
.pending-filters {
    margin-bottom: 6px;
    /* 减少间距 */
}

.pending-title {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
}

.pending-tags .el-tag {
    margin: 0 4px 4px 0;
}

/* 已应用过滤条件 */
.applied-filters {
    margin-bottom: 6px;
    /* 减少间距 */
}

.applied-title {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
}

.applied-tags .el-tag {
    margin: 0 4px 4px 0;
}

/* 操作按钮 */
.filter-actions {
    text-align: right;
    padding-top: 6px;
    /* 减少顶部间距 */
    /* border-top: 1px solid #ebeef5;*/
    display: flex;
    /*  justify-content: flex-end;*/
    gap: 6px;
    /* 减少按钮间距 */
    margin-top: 8px;
}
</style>

<style scoped>
.center {
    display: flex;
    flex: 1;
}

.ucenter_main {
    min-height: 500px;
}

/* 只作用于本页导入列表，强制收紧 el-table 行高，防止被全局样式二次拉伸 */
.wrap .right_con .rc_table.el-table .el-table__cell {
    padding: 10px 0 !important;
    vertical-align: middle !important;
}

.wrap .right_con .rc_table.el-table th.el-table__cell {
    padding: 10px 0 !important;
}

.wrap .right_con .rc_table.el-table th.el-table__cell>.cell {
    padding: 0 14px !important;
}

/* 再次限定每行最大高度，防止“像跑马灯一样”不断拉伸 */
.wrap .right_con .rc_table.el-table .el-table__row {
    height: 56px !important;
    max-height: 56px !important;
    overflow: hidden;
}

.wrap .right_con .rc_table.el-table .el-table__row .cell {
    line-height: 1.4;
}

/* 覆盖订单详情页对 .el-table 的全局行高设置，避免导入列表行距过大，仅作用于本页表格 */
.rc_table.el-table .el-table__cell {
    padding: 12px 0;
    vertical-align: middle;
}

.rc_table.el-table th.el-table__cell {
    padding: 12px 0;
}

.rc_table.el-table th.el-table__cell>.cell {
    padding: 0 14px;
}

/* 强制锁定导入列表各层容器宽度为 100%，防止 Element Table 计算宽度时一点点变大 */
.wrap .right_con .rc_table.el-table {
    width: 100% !important;
    max-width: 100% !important;
}

.wrap .right_con .rc_table.el-table .el-table__header-wrapper,
.wrap .right_con .rc_table.el-table .el-table__body-wrapper,
.wrap .right_con .rc_table.el-table .el-table__footer-wrapper {
    width: 100% !important;
}

.wrap .right_con .rc_table.el-table table {
    width: 100% !important;
    table-layout: fixed;
}

/* 特别控制状态列，防止内容撑开表格 */
.wrap .right_con .rc_table.el-table .el-table__body-wrapper .el-table__row .el-table__cell:nth-child(5) {
    width: 180px !important;
    max-width: 180px !important;
    min-width: 180px !important;
    overflow: hidden !important;
}

.wrap .right_con .rc_table.el-table .el-table__header-wrapper .el-table__header .el-table__cell:nth-child(5) {
    width: 180px !important;
    max-width: 180px !important;
    min-width: 180px !important;
}

/* 导入表格专用样式 */
.import_table.el-table {
    table-layout: fixed !important;
    width: 100% !important;
}

.import_table.el-table .el-table__cell {
    overflow: hidden;
    padding: 8px 0 !important;
}

.import_table.el-table .cell {
    overflow: hidden;
    padding: 0 8px;
}

/* 文本省略样式 */
.text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}

/* 数量信息样式 */
.quantity-info {
    font-size: 12px;
    line-height: 1.2;
    width: 100%;
    overflow: hidden;
}

.quantity-info>div {
    margin: 1px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 严格控制导入表格各列宽度 */
.import_table.el-table table,
.import_table.el-table .el-table__header-wrapper table,
.import_table.el-table .el-table__body-wrapper table {
    width: auto !important;
    /* 允许表格根据列宽自动决定宽度，避免强制100%导致的溢出或压缩 */
    table-layout: fixed !important;
}

/* 确保导入表格容器不超出 */
.import_table.el-table {
    width: 100% !important;
    max-width: 100%;
}

/* 强制表格内容自动换行，显示完整 */
.log-title-group {
    width: 100%;
    padding: 5px 0;
}

.log-title-item {
    width: 100%;
    text-align: left;
    line-height: 1.5;
    padding: 2px 0;
    /* 核心：自动换行 + 显示全部 */
    white-space: normal !important;
    word-break: break-all !important;
    overflow: visible !important;
}
</style>
